module.exports = __webpack_public_path__ + "static/media/circle-x-fade.aeedbedc.svg";